import React from 'react'
import { useStyles } from './SidePanelLayout.styles'

interface SidePanelLayoutProps {
  header?: React.ReactNode
  content?: React.ReactNode
  noBackground?: boolean
}

export const SidePanelLayout: React.FC<SidePanelLayoutProps> = ({
  header,
  content,
  noBackground = false,
}) => {
  const { classes } = useStyles({ noBackground })

  return (
    <div className={classes.layout}>
      {header}
      <div className={classes.contentWrapper}>{content}</div>
    </div>
  )
}
